import { ShowcaseData } from "./showcaseData";

/** Класс для данных о странице витрины */

export class ShowcasePageData {

  /** Идентификатор страницы витрины */
  public Id: number = 0;

  /** Тип страницы витрины */
  public Type: string = "";

  /** Заголовок страницы витрины */
  public Caption: string = "";

  /** Массив элементов витрины */
  public ShowcaseItems: ShowcaseData[] = [];

  public Data: any = {};

  public isRoot: boolean = false;

  constructor(src: any) {
    this.Id = src.id ?? 0;
    this.Type = src.type ?? '';
    this.Caption = src.caption ?? '';
    this.Data = src.data ?? null;

    if (src.data?.list) {
      this.ShowcaseItems = src.data.list.map((item: any) => new ShowcaseData(item));
    }
  }
}